
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Text from 'components/Text';

import { formatPrice } from 'helpers/Price';

import './totalPrice.styles.scss';

export default class TotalPrice extends Component {
    renderUnitPrice() {
        const {unitPrice, type, totalPrice, unitPriceText } = this.props;

        if (unitPrice === totalPrice) {
            return null;
        }

        if (!unitPriceText) {
            return (
                <div className={'product__price-' + type}>
                    {formatPrice(unitPrice)}
                </div>
            );
        }

        return (
            <div className={'product__price-' + type}>
                {formatPrice(unitPrice) + ' / ' + unitPriceText}
            </div>
        );
    }
    render() {
        const { type, breathTakingItem, unitPrice, totalPrice, oldPrice, typeText, isTRO, isNLP, ValidToDateTime } = this.props;

        let troClass = '';
        if (isTRO) {
            troClass = ' product__price--tro';
        }

        let breathTakingItemClass = '';
        if (window.Checkout.settings.show_breathtaking_label && breathTakingItem) {
            breathTakingItemClass += ' product__total--breathtaking';
        }
        if (unitPrice === false) {
            return null;
        }
        return (
            <div className={'product__price-type product__price-type-' + type + troClass}>
                {isNLP && window.Checkout.settings.show_nlp_offers &&
                    <div>
                        <div className="product__new-lower-price">
                            <span><Text textKey="price_package_new_lower_price_text" /></span>
                        </div>
                    </div>
                }
                {typeText && typeText !== '' &&
                    <div className={'product__price-type-text product__price-type-text-' + type}>
                        <Text textKey={typeText} />
                    </div>
                }
                {isTRO &&
                    <div>
                        <span className="product__price-old">
                            {formatPrice(oldPrice)}
                        </span>
                        {this.renderUnitPrice()}
                    </div>
                }
                <div className={'product__total product__total-' + type + breathTakingItemClass}>
                    {formatPrice(totalPrice)}
                </div>
                {!isTRO &&
                    this.renderUnitPrice()
                }
                {ValidToDateTime && ((window.Checkout.settings.show_nlp_offers && isNLP && window.Checkout.settings.show_nlp_valid_date) || isTRO) &&
                    <div className={'product__valid-to product__valid-to-' + type}>
                        <Text textKey="price_package_valid_until" /> {ValidToDateTime}
                    </div>
                }
            </div>
        );
    }
}

TotalPrice.propTypes = {
    unitPriceText: PropTypes.string,
    breathTakingItem: PropTypes.bool,
    type: PropTypes.string.isRequired,
    typeText: PropTypes.string,
    unitPrice: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.bool,
    ]).isRequired,
    totalPrice: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.bool,
    ]).isRequired,
    oldPrice: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.bool,
    ]),
    isTRO: PropTypes.bool.isRequired,
    isNLP: PropTypes.bool.isRequired,
    ValidToDateTime: PropTypes.any,
};
